<template lang="pug">
.ticket-order
  operation-page(title="订单确认" btn="确认支付" @next="onSubmit")
    ticket-confirm-card(:ticketId="id")
</template>
<script>
import OperationPage from '@/components/layout/OperationPage'
import TicketConfirmCard from '@/components/home/TicketConfirmCard'
import { mapActions, mapMutations, mapState } from 'vuex'
import AlipayService from '@/services/AlipayService'
export default {
  name: 'TicketOrder',
  components: { TicketConfirmCard, OperationPage },
  props: {
    id: {},
  },
  data() {
    return {
      order: null,
    }
  },
  computed: {
    ...mapState('app', ['router']),
  },
  methods: {
    ...mapMutations('app', ['setRouterBack', 'setRouterLast', 'setPending']),
    ...mapActions('app', ['TicketAbort', 'TicketConfirm']),
    onSubmit() {
      if (this.orderId && this.tradeNo) {
        this.payRequest()
      } else {
        this.orderSubmit()
      }
    },
    onMessage(e) {
      if (e.msg === AlipayService.Events.TICKET_ORDER_SUBMITTED) {
        console.log('res submitted!!!', e)
        this.orderId = e.data.res.orderId
        this.tradeNo = e.data.res.tradeNo
        //this.tradeNo = e.data.res.tradeNo
        this.setPending(false)
        this.payRequest()
      }
      if (e.msg === AlipayService.Events.PAY_SUCCESS) {
        this.setPending(true)
        console.log('suc', e)
        this.TicketConfirm({
          orderId: this.orderId,
        }).then((res) => {
          this.setPending(false)
          this.goBack()
        })
        // setTimeout(() => {
        //   this.setRouterBack('/')
        //   this.$router.replace(`/reservation/res5?resId=${this.res.resId}`)
        // }, 200)
      }
    },

    goBack() {
      setTimeout(() => {
        if (this.$route.path !== this.router.back)
          this.$router.replace(this.router.back)
      }, 200)
    },
    orderSubmit() {
      let order = {
        ticketId: this.id,
      }
      console.log('order submit', order)
      AlipayService.sendEvent(AlipayService.Events.TICKET_ORDER_SUBMIT, order)
      AlipayService.on(AlipayService.Events.ONMESSAGE, this.onMessage)
      //this.$router.replace('/reservation/res5')
      this.setPending(true)
    },
    payRequest() {
      AlipayService.sendEvent(AlipayService.Events.PAY_REQUEST, this.tradeNo)
    },
    onNotice() {
      this.showNotice = true
    },
  },
  mounted() {},
  beforeRouteLeave(to, from, next) {
    console.log(to, from)
    if (to.path.indexOf('/home/ticketOrder') === -1) {
      if (this.orderId) {
        console.log('!!!!!!!!!!!!!Abort')
        this.TicketAbort(this.orderId)
        this.orderId = null
      }
    }
    next()
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.slide-enter-active, .slide-leave-active
  transition: all 0.5s
.slide-enter, .slide-leave-to
  transform: translateX(-100%)
</style>
